import iframeResize from 'iframe-resizer/js/iframeResizer';
import { initIframeEventListener } from './iframeEventListener';
import { initExternalEventBus } from './externalEventBus';
import { initAffiliateListener } from './affiliateListener';
import { initLegacyAffiliateListener } from './affiliateLegacyListener';
import { attachCookiebotParentListeners } from './cookiebotListeners';
import { attachHubspotListeners } from './hubspotEventListeners';
import * as Sentry from '@sentry/browser';

export const IFRAME_STYLE = 'width: 100%; min-height: 600px; border: 0px;';

export function createIframe(path, iframeDomain, utm = {}) {
  // Create src
  const src = new URL(iframeDomain ?? `https://${process.env.DOMAIN}`);
  src.pathname = path;
  src.searchParams.append('referrer', global.location.href);
  if (Object.values(utm).length) {
    const parsedUtm = {
      // use source as campaign ifm not set
      ...{ campaign: utm.source },
      ...{ content: 'tool', medium: 'referral' },
      ...utm,
    };
    Object.keys(parsedUtm).forEach(key => src.searchParams.append(`utm_${key}`, parsedUtm[key]));
  }

  // Create frame
  const iframe = global.document.createElement('iframe');
  iframe.src = src.href;
  iframe.style = IFRAME_STYLE;

  return iframe;
}

export function mountIframe({ id, path, iframeDomain, minHeight = 250, utm = {} }) {
  if (!global.document)
    return;

  const containerEl = global.document.getElementById(id);

  if (!containerEl) {
    // eslint-disable-next-line no-console
    console.warn('Couldn\'t mount vue iframe entry, el not found', { containerEl, id });
    return;
  }

  const iframe = createIframe(path, iframeDomain, utm);
  containerEl.classList.remove('loading');
  containerEl.append(iframe);

  let frameInitialized = false;

  iframeResize({
    checkOrigin: false,
    heightCalculationMethod: 'grow',
    minHeight,
    onInit: () => frameInitialized = true,
    // log: loggerLevel === 'info',
  }, iframe);

  setTimeout(() => {
    if (frameInitialized)
      return;

    Sentry.setContext('iFrame', { path });
    Sentry.captureException(new Error('iFrame not initialized'));
  }, 5000);

  return iframe;
}

export function initEventHandlers({ iframe, appOptions }) {
  // one event bus for an iframe
  const $bus = initExternalEventBus();
  initIframeEventListener({ iframe, $bus });

  // attach consumers
  initAffiliateListener({ $bus, appOptions });
  initLegacyAffiliateListener({ $bus, appOptions });
  attachCookiebotParentListeners({ iframe });
  attachHubspotListeners();
}
